import styled from 'styled-components'

export const StyledTable = styled.table`
  width: 100%;
  max-width: 100%;
  margin-bottom: 1rem;
`

export const StyledTableBody = styled.tbody`
  tr:nth-of-type(odd) {
    background-color: #ecf0f6;
  }
`

export const TH = styled.th`
  vertical-align: baseline;
  border-top: 1px solid #ececec;
  padding: 0.75rem;
  text-align: left;
`
